import PageStaticTemplate from './PageStaticTemplate';

const PageStaticFAQ = ({ overlay }) => {
    return (
        <PageStaticTemplate page='static.faq' apiUrl='/static-pages/62fbd0c2e2654aac50328def' icon='MessageQuestion' overlay={overlay} analyticsPage='FAQ' />
    );
};

export default PageStaticFAQ;
